export default __webpack_public_path__ + "static/media/medical_9.c885adfa.jpg";